import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import TextArea from '../../modules/TextArea';
import SelectBox from '../../modules/SelectBox';
import Button from '../../modules/Button';
import InputGroup from '../../modules/InputGroup';
import FormButtonPanel from '../../modules/FormButtonPanel';
import AlertBox from '../../modules/AlertBox';

import * as formScroller from '../../../services/forms/scroller';
import * as serviceActions from '../../../actions/services';
import { selectSessionUserId } from '../../../selectors/users';
import AlertMessage from "../../modules/AlertMessage/index";

class MyData extends React.Component {

    componentDidMount() {
        this.props.resetServices();
        this.props.refreshServices(this.props.sessionUserId);
    }

    render() {

        const {
            submitSucceeded,
            submitFailed,
            handleSubmit,
            pristine,
            submitting,
            formValues
        } = this.props;

        return (
            <div>
                <AlertMessage>
                    {(submitSucceeded || submitFailed) && (
                        <AlertBox
                            theme={submitSucceeded ? 'success' : 'danger'}
                        >
                            {submitSucceeded ? 'Your enquiry has been sent.' : 'There was a problem sending your enquiry.'}
                        </AlertBox>
                    )}
                </AlertMessage>


                <form onSubmit={handleSubmit}>
                    <InputGroup>
                        <Field name="service" component={SelectBox} label="Service" required="true">
                            <option value="">Select a service...</option>
                            <option value="all">All Services</option>
                            {this.props.services.map(service => {
                                return (
                                    <option value={service.id} key={service.id}>{ service.name }</option>
                                )
                            })}
                        </Field>
                    </InputGroup>

                    <InputGroup>
                        <Field name="enquiry" component={SelectBox} label="Enquiry" required="true">
                            <option value="">Choose an enquiry...</option>
                            <option value="delete">I want my data to be deleted</option>
                            <option value="change">I want to make a change to my data</option>
                            <option value="access">I want access to my data</option>
                            <option value="usage">I want to know how my data is used</option>
                            <option value="other">I have another type of enquiry</option>
                        </Field>
                    </InputGroup>

                    <InputGroup>
                        <Field
                            name="message"
                            component={TextArea}
                            type="text"
                            label="Message"
                            required={formValues.enquiry === 'other'}
                        />
                    </InputGroup>

                    <FormButtonPanel position="bottom">
                        <Button disabled={pristine || submitting} type="submit">Send Enquiry</Button>
                    </FormButtonPanel>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        services: state.services.userServices,
        sessionUserId: selectSessionUserId(state),
        formValues: {
            enquiry: formValueSelector('my-data')(state, 'enquiry')
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        resetServices() {
            dispatch(serviceActions.refreshUserServicesReceived([]));
        },
        refreshServices(userId) {
            dispatch(serviceActions.refreshUserServices(userId));
        }
    }
}

const formConfig = {
    form: 'my-data',
    onSubmitSuccess: formScroller.scrollToTop,
    onSubmitFail: formScroller.scrollToFirstError
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(MyData));